<template>
    <div class="industry-list industry-list-radio">
        <div class="industry-list-head border-bottom">请选择行业</div>
        <!--        <div class="scroll-view">-->
        <IScrollView ref="iscrollview" class="iscrollview" :options="options">
            <div class="industry-list-body">

                <p class="no-data" v-if="induList.length === 0">暂无数据</p>
                <!-- 一级 -->
                <div class="pri" v-for="(pri, priIdx) in induList" :key="priIdx">
                    <div class="pri-txt border-bottom"><span>{{pri.name}}</span></div>

                    <!-- 二级 -->
                    <div class="sec border-bottom" v-for="(sec, secIdx) in pri.children" :key="secIdx">

                        <div class="sec-txt">{{sec.name}}</div>

                        <!-- 三级 -->
                        <div class="ter">
                            <div class="ter-txt"
                                 v-for="(ter, terIdx) in sec.children" :key="terIdx"
                                 @click="terClick(ter, sec, pri)"
                                 :class="{on: value === ter.id}">
                                {{ter.name}}
                            </div>
                            <!--<div class="ter-txt">中游制造中游制造中 造</div>-->
                        </div>

                    </div>
                </div>

            </div>
        </IScrollView>

        <!--        </div>-->

    </div>
</template>
<script>
    // window.location.reload()

    import IScrollView from "../iIScrollView/IScrollView";

    export default {
        props: {
            induList: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: String,
            }
        },
        watch: {
            induList: {
                handler() {
                    this.$nextTick(() => {
                        this.$refs.iscrollview.refresh()
                    });
                },
                immediate: true
            }
        },
        components: {
            IScrollView
        },
        data() {
            return {
                options: {
                    scrollX: false,
                    scrollY: true,
                    click: true,
                    keyBindings: true,
//加入以下三个可解决
                    disablePointer:true,
                    disableTouch:false,
                    disableMouse:true
                },
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.iscrollview.refresh()
            })
        },

        methods: {

            // 三级
            terClick(ter, sec, pri) {
                this.$emit('submit', ter.id, ter.name);

            },

        }
    }
</script>